import { IconLabelItem } from '../atoms/IconLabelItem';
import { styled } from '@mui/material/styles';

export type IconLabelListProps = {
  list: { icon?: string; text: string; span?: string }[];
};

const StyledContainer = styled('div')(
  ({ theme }) => `
  color: ${theme.palette.neutral[50]};
  display: flex;
  flex-direct: row nowrap;
  align-items: center;
`,
);

type DivProps = {
  first: boolean;
};

const StyledContainerDetail = styled('div')<DivProps>(
  ({ theme, first }) => `
  padding-right: 0.5em;
  border-left: ${first ? '' : `1px solid ${theme.palette.neutral[50]}`}};
  height: 21px;
`,
);

const IconLabelList = ({ list }: IconLabelListProps) => {
  return (
    <StyledContainer>
      {list.map((element, i) => {
        return (
          <StyledContainerDetail first={i === 0 ? true : false} key={i}>
            <IconLabelItem emoji={element?.icon} text={element.text} span={element.span} />
          </StyledContainerDetail>
        );
      })}
    </StyledContainer>
  );
};

export default IconLabelList;
export { IconLabelList };
